import React, { Component } from 'react';
import { connect} from "remx";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";
import broker from "../../utils/broker";


class SidebarTree extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            data_klasifikasi : [],
            data_kategori_per: [],
            data_sub: [],
            nav_data : {},
            klasifikasi_sub: {},
            child_data : {},
            kategori_id : '',
            klasifikasi_id : '',
        }
        this.toggleNav = this.toggleNav.bind(this);
    }

    getDataKlasifikasiSub(id){
        broker.fetch.get(`/list/klasifikasi/${id}/sub`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_sub : data.data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    getDataKategori(){
        let nav = {}
        let klasifikasi_sub = {}
        broker.fetch.get(`/data/user/${this.props.user.id}/kategori_child`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                // dataStore.setters.setDataKategori(data.data);
                this.setState({data_kategori : data.data}, function(){
                      var data_kategori = this.state.data_kategori;
                        for (var i=0; i<data_kategori.length; i++){
                            nav[data_kategori[i].id] = '';
                            for (var j=0; j<data_kategori[i].kategori.klasifikasi.length; j++){
                                klasifikasi_sub[data_kategori[i].kategori.klasifikasi[j].id] = 'collapse';
                            }
                        }
                        this.setState({nav_data : nav, klasifikasi_sub : klasifikasi_sub})
                });
                
                if (!this.props.data_kategori_per.id_kategori) {
                    dataStore.setters.setDataKategoriPer({id_kategori : data.data[0].kategori.id, 
                                                        nama_kategori : data.data[0].kategori.nama_keterangan, 
                    });  
                }
            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        dataStore.setters.setDataPer({})
        this.getDataKategori();
    }
    

    toggleNav(e, id, kategori_id, kategori_nama){
        e.preventDefault();

        dataStore.setters.setDataKlasifikasi({kategori_id : kategori_id, klasifikasi_id : '', sub_klasifikasi_id : ''});
        dataStore.setters.setDataKategoriPer({id_kategori : kategori_id, nama_kategori :kategori_nama});  

        var nav_data = this.state.nav_data;
    
        for (var key in nav_data){
            nav_data[key] = '';
            if (key === id){
                nav_data[key] = (nav_data[key] === '') ? ' show' : '';
            }
        }

        var child_data = this.state.child_data;
        for (var index in child_data){
            child_data[index] = '';
        }
    
        this.setState({nav_data : nav_data, child_data: child_data});
    }

    setKlasifikasi(e, kategori_id, klasifikasi_id, nama_kategori){
        e.preventDefault();

        this.setState({child_data : {[klasifikasi_id] : 'active'}, klasifikasi_id : klasifikasi_id});
        this.getDataKlasifikasiSub(klasifikasi_id);

        dataStore.setters.setDataKlasifikasi({kategori_id : kategori_id, klasifikasi_id : klasifikasi_id, sub_klasifikasi_id : ''});
        dataStore.setters.setDataKategoriPer({id_kategori : kategori_id, nama_kategori: nama_kategori});  

        var klasifikasi_sub = this.state.klasifikasi_sub;
        for (var key in klasifikasi_sub){
            klasifikasi_sub[key] = 'collapse';
            if (key === klasifikasi_id){
                klasifikasi_sub[key] = (klasifikasi_sub[key] === 'nav') ? 'collapse' : 'nav';
            }
        }

        this.setState({klasifikasi_sub : klasifikasi_sub});
    }

    generateContent(){
        var content = this.state.data_klasifikasi;
        let return_content = [];
        for (var key in content){
            if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                return_content.push(<React.Fragment key={key}>
                                        <label className="nav-label mg-b-1-f" key={key}>{key.replace("_", " ")}</label>
                                        <p className="tx-13 mg-b-10">{content[key]}</p>
                                    </React.Fragment>);

        }
        return return_content;
    }

    render(){
        return(
            <React.Fragment>
                <div className="filemgr-sidebar">
                    <div className="filemgr-sidebar-header">
                        <h6 align="center"><i className="far fa-folder mg-r-10"></i>Kategori Pekerjaan</h6>
                    </div>
                    <div className="filemgr-sidebar-body">
                        <div className="pd-t-20 pd-b-10 pd-x-30">
                            <ul className="sidebar-nav">
                                {(this.state.data_kategori) &&
                                    this.state.data_kategori.map((data, i) => {
                                        return <li className={"nav-item" + this.state.nav_data[data.id]} key={i}>
                                                    <a href='#!' onClick={(e) => this.toggleNav(e, data.id, data.kategori_id, data.kategori.nama_keterangan)} 
                                                        className={"nav-link with-sub cursor-pointer " + ((this.props.data_kategori_per.id_kategori === data.kategori_id) ? 'active' : '')}> 
                                                        {data.kategori.nama_keterangan}
                                                    </a>
                                                    <nav className="nav">
                                                    {(data.kategori.klasifikasi) &&
                                                        data.kategori.klasifikasi.map((klasifikasi, j) =>{
                                                            return <li className={"nav-item"} key={j}>
                                                                        <a href='#!' onClick={(e) => this.setKlasifikasi(e, data.kategori_id, klasifikasi.id, data.kategori.nama_keterangan)} 
                                                                            className={"cursor-pointer " + ((this.state.child_data[klasifikasi.id]) ? this.state.child_data[klasifikasi.id] : '')} key={j}>
                                                                                {klasifikasi.nama}
                                                                        </a>
                                                                    </li>
                                                        })
                                                    }
                                                    </nav>
                                                </li>})
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
        data_klasifikasi : dataStore.getters.getDataKlasifikasi()
    }
}

export default connect(mapStateToProps)(SidebarTree);